module.exports = __webpack_public_path__ + "static/img/scene1.dbbc7341.jpg";